import React, { useEffect } from 'react';
import { shapes } from '@cimpress/react-components';
import { AlignItems, JustifyContent } from '../../utils/css-classes';

const { Spinner } = shapes;

interface Props {
  showOverlay: boolean;
}

// tslint:disable-next-line:variable-name
const Loading = ({ showOverlay }: Props) => {
  useEffect(
    () => {
      if (showOverlay) {
        document.body.classList.add('modal-open');
      } else {
        document.body.classList.remove('modal-open');
      }
    },
    [showOverlay],
  );

  if (showOverlay) {
    return (
      <div className={`loading-overlay ${AlignItems.CENTER} ${JustifyContent.CENTER}`}>
        <Spinner />
      </div>
    );
  }

  return null;
};

export default Loading;
